/* ========================================================================== *\
    IMPORTS
\* ========================================================================== */

import { bind, forEach, isNil } from 'lodash';
import { push } from '../../01-helpers/utilities/tag-manager';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
    PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'ga-data-layer',
    baseCssClass = `js-${moduleName}`,
    attributeNames = {
        gaAddToCart: 'data-ga-add-to-cart',
        gaIdentifierArticleType: 'data-ga-identifier-article-type',
        gaIdentifierPaginationArrow: 'data-ga-identifier-pagination-arrow',
        gaIdentifierPaginationNumber: 'data-ga-identifier-pagination-number',
        gaProductId: 'data-ga-product-id',
        gaRemoveFromCart: 'data-ga-remove-from-cart',
        paginationPage: 'data-page',
    },
    selectors = {
        base: `.${baseCssClass}`,
        cta: `.${baseCssClass}-cta`,
        heading: `.${baseCssClass}-heading`,
        productvariant: `.${baseCssClass}-productvariant`,
        sku: `.${baseCssClass}-sku`,
        id: `.${baseCssClass}-id`,
        price: `.${baseCssClass}-price`,
        quantity: `.${baseCssClass}-quantity`
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
    EVENT HANDLING
\* ========================================================================== */

function bindClicks() {
    let el = document.querySelectorAll(".js-shoplist--link");
    for (let i = 0; i < el.length; i++) {
        el[i].onclick = function (e) {
            let memberprice, price, discount = 0;

            let id = this.querySelector('.js-shoplist--id').innerText;
            if(this.querySelector('.js-shoplist--memberprice') && this.querySelector('.js-price')) {
                memberprice = parseFloat(this.querySelector('.js-shoplist--memberprice').innerHTML.replace(',', '.')).toFixed(2);
                price = parseFloat(this.querySelector('.js-price').innerHTML.replace(',', '.')).toFixed(2);
                discount = parseFloat(price - memberprice).toFixed(2);
            }

            let productObject = {
                'id' : this.querySelector('.js-shoplist--id').innerText,
                'index' : i,
                'category' : this.parentNode.parentNode.previousElementSibling.querySelector('h2').innerText,
                'discount' : discount
            }
            if(id) {
                localStorage.setItem(this.querySelector('.js-shoplist--id').innerText, JSON.stringify(productObject));
            }

        };

    }
}

function bindEvents() {


    if (this.cta === null) {
        return;
    }

    if (this.cta.closest(selectors.base).hasAttribute(attributeNames.gaIdentifierArticleType)) {
        this.cta.addEventListener('click', bind(onClickArticleType, this))
    } else if (this.cta.hasAttribute(attributeNames.gaIdentifierPaginationArrow)) {
        this.cta.addEventListener('click', bind(onClickPaginationArrow, this))
    } else if (this.cta.hasAttribute(attributeNames.gaIdentifierPaginationNumber)) {
        this.cta.addEventListener('click', bind(onClickPaginationNumber, this))
    } else if (this.cta.hasAttribute(attributeNames.gaAddToCart)) {
        this.cta.addEventListener('click', bind(onClickAddToCart, this));
    } else if (this.cta.hasAttribute(attributeNames.gaRemoveFromCart)) {
        this.cta.addEventListener('click', bind(onClickRemoveFromCart, this));
    } else {
        this.cta.addEventListener('click', bind(onClickCta, this));
    }
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
    PRIVATE METHODS
\* ========================================================================== */

function onClickAddToCart() {
    const
        heading = this.baseElement.querySelector(selectors.heading)?.innerText,
        productvariant = this.baseElement.querySelector(selectors.productvariant)?.innerText,
        sku = this.baseElement.querySelector(selectors.sku)?.innerText,
        id = this.baseElement.querySelector(selectors.id)?.value,
        quantity = Number(this.baseElement.querySelector(selectors.quantity)?.value),
        price = this.baseElement.querySelector(selectors.price)?.innerText,
        priceConverted = Number(price.replace(/,/g, '.'));
        let ls = {};
        ls.discount, ls.index, ls.category = null;
        if(localStorage.getItem(sku)) {
            ls = JSON.parse(localStorage.getItem(sku));
    }

    // Get variant from selectmenu on detailpage 
    let variant = '';
    const product_variant = document.getElementById("product_variant");
    
    if (product_variant > 0) {
        let sel_option = product_variant.options[product_variant.selectedIndex];
        variant = sel_option.getAttribute("data-shop-variant-name");
    }

    push({ ecommerce: null });  // Clear the previous ecommerce object.
    push({
        'event': 'add_to_cart',
        'ecommerce': {
            'currency': 'EUR',
            'value': priceConverted,
            'items': [
                {
                    'item_id': id,
                    'item_name': heading, // fill this variable with the item name
                    'item_variant': variant, // fill this variable with the item name
                    'coupon': '', // Not available
                    'discount': 0,
                    'index': ls.index ? ls.index : 0,
                    'item_category': ls.category ? ls.category : '', 
                    'item_list_name': '', // Not available
                    'price': priceConverted,
                    'quantity': quantity
                }
            ]
        }
    });
}


function onClickArticleType() {
    const
        type = this.baseElement.getAttribute(attributeNames.gaIdentifierArticleType),
        heading = this.cta.querySelector('.js-data-layer-heading')?.innerText;

    push({
        'event': 'list_article_click', // UA
        'eventName': 'list_article_click', // GA4
        'article_name': heading, // GA4
        'article_content_type': type, // GA4
        'eventCategory': 'article_list', // UA
        'eventAction': 'article_click', // UA
        'eventLabel': type, // UA
    });
}


function onClickCta() {
    const
        target = this.cta,
        href = target.href,
        text = target.outerText;

    push({
        'event': 'call_to_action', // UA
        'eventName': 'call_to_action', // GA4
        'call_to_action_name': text, // GA4
        'destination_url': href, // GA4
        'eventCategory': 'call_to_action', // UA
        'eventAction': text, // UA
        'eventLabel': href  // UA
    })
}

function onClickPaginationArrow() {
    const
        target = this.cta,
        direction = target.getAttribute(attributeNames.gaIdentifierPaginationArrow),
        pageNumber = target.getAttribute(attributeNames.paginationPage);

    push({
        'event': 'pagination_navigation_arrow', // UA
        'eventName': 'pagination_navigation_arrow', // GA4
        'pagination_direction': direction, // GA4 
        'destination_page_number': pageNumber, // GA4 
        'eventCategory': 'pagination_navigation', // UA
        'eventAction': 'arrow_click', // UA
        'eventLabel': direction, // UA 
    });
}

function onClickPaginationNumber() {
    const
        pageNumber = this.cta.getAttribute(attributeNames.paginationPage);

    push({
        'event': 'pagination_navigation_number', // UA
        'eventName': 'pagination_navigation_number', // GA4
        'destination_page_number': pageNumber, // GA4 
        'eventCategory': 'pagination_navigation', // UA
        'eventAction': 'number_click', // UA
        'eventLabel': pageNumber, // UA
    });
}

function onClickRemoveFromCart(e) {
    const
        heading = this.baseElement.querySelector(selectors.heading)?.innerText,
        sku = this.baseElement.querySelector(selectors.sku)?.innerText,
        id = this.baseElement.getAttribute(attributeNames.gaProductId),
        price = this.baseElement.querySelector(selectors.price)?.innerText,
        priceConverted = Number(price.replace(/,/g, '.')),
        quantity = Number(this.baseElement.querySelector(selectors.quantity)?.value);
        let ls = {};
        ls.discount, ls.index, ls.category = null;

        if(localStorage.getItem(sku)) {
            ls = JSON.parse(localStorage.getItem(sku));
    }


    push({ ecommerce: null });  // Clear the previous ecommerce object.
    push({
        event: 'remove_from_cart',
        ecommerce: {
            'currency': 'EUR',
            'value': priceConverted,
            'items': [
                {
                    'item_id': id,
                    'item_name': heading, // fill this variable with the item name
                    'coupon': '', // Not available
                    'discount': 0,
                    'index': ls.index ? ls.index : 0,
                    'item_category': ls.category ? ls.category : '',
                    'item_list_name': '', // Not available
                    'price': priceConverted,
                    'quantity': quantity
                }
            ]
        }
    });
}

/* == PRIVATE METHODS ======================================================= */



/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */

export class GoogleAnalyticsDataLayer {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of GoogleAnalyticsDataLayer, no base element has been provided';
        }

        this.baseElement = baseElement;
        this.cta = baseElement.querySelector(selectors.cta);

        bindEvents.call(this);
        bindClicks.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */
}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
    INITIALIZATION
\* ========================================================================== */

function init(baseElements = document.querySelectorAll(selectors.base)) {
    forEach(baseElements, baseElement => {
        new GoogleAnalyticsDataLayer(baseElement);
    });
}

init();

/* == INITIALIZATION ======================================================== */